import React from 'react';

const CoreValues = () => {
  const values = [
    {
      title: "Technical Precision",
      icon: "fas fa-microscope",
      description: "Every calculation, every assessment, every recommendation is backed by rigorous technical analysis and industry standards.",
      color: "from-blue-500 to-blue-700"
    },
    {
      title: "Reliability",
      icon: "fas fa-shield-alt",
      description: "Our solutions are designed to perform consistently under all conditions, ensuring your operations remain safe and compliant.",
      color: "from-green-500 to-green-700"
    },
    {
      title: "Safety Culture",
      icon: "fas fa-hard-hat",
      description: "We don't just implement safety systems; we foster a culture where safety is paramount in every decision and action.",
      color: "from-orange-500 to-orange-700"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Core Values</h2>
          <p className="text-xl text-gray-600">The principles that guide everything we do</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="relative group">
              <div className={`absolute inset-0 bg-gradient-to-br ${value.color} rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
              <div className="relative bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 hover:transform hover:-translate-y-2">
                <div className="text-center">
                  <i className={`${value.icon} text-5xl text-gray-800 group-hover:text-white mb-6 block transition-colors`}></i>
                  <h3 className="text-2xl font-bold text-gray-900 group-hover:text-white mb-4 transition-colors">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 group-hover:text-gray-100 leading-relaxed transition-colors">
                    {value.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <img
            src="/assets/asset-19.jpg"
            alt="Engineering diagrams"
            className="inline-block rounded-lg shadow-xl max-w-2xl w-full"
          />
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
